import { useEffect, useState } from "react";
import { ResponsiveContainer, LineChart, Line, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, ReferenceLine, ComposedChart } from "recharts";
import { money } from "@/lib/fmt";

const axis = { stroke: "#A8A29E", fontSize: 11, tickLine: false, axisLine: false };
const tip = { contentStyle: { background: "#1C1917", border: "none", borderRadius: 8, color: "#fff", fontSize: 12 }, labelStyle: { color: "#D6D3D1" } };

export function useMeasured() {
  const [el, setEl] = useState(null);
  const [ok, setOk] = useState(false);
  useEffect(() => {
    if (!el) return undefined;
    const ro = new ResizeObserver(([e]) => setOk(e.contentRect.width > 0 && e.contentRect.height > 0));
    ro.observe(el);
    return () => ro.disconnect();
  }, [el]);
  return [setEl, ok];
}

export function Chart({ type, data, dataKey, fmt = (v) => v, goalKey, height = 260 }) {
  const [ref, ok] = useMeasured();
  if (!data?.length) return <div className="h-[200px] flex items-center justify-center text-sm text-stone-500">Not enough data yet.</div>;
  return (
    <div ref={ref} style={{ height }} data-testid={`chart-${dataKey}`}>
      {ok && <ResponsiveContainer width="100%" height="100%" initialDimension={{ width: 1, height: 1 }}>
        {type === "bar" ? (
          <ComposedChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
            <CartesianGrid vertical={false} stroke="#EFEBE3" />
            <XAxis dataKey="label" {...axis} />
            <YAxis {...axis} tickFormatter={fmt} width={56} />
            <Tooltip {...tip} formatter={(v) => fmt(v)} cursor={{ fill: "#F3EFE6" }} />
            <Bar dataKey={dataKey} fill="#1C1917" radius={[4, 4, 0, 0]} />
            {goalKey && <Line dataKey={goalKey} stroke="#9E2A2B" strokeDasharray="5 4" dot={false} strokeWidth={2} />}
          </ComposedChart>
        ) : (
          <LineChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
            <CartesianGrid vertical={false} stroke="#EFEBE3" />
            <XAxis dataKey="label" {...axis} interval="preserveStartEnd" />
            <YAxis {...axis} tickFormatter={fmt} width={56} />
            <Tooltip {...tip} formatter={(v) => fmt(v)} />
            <Line dataKey={dataKey} stroke="#1C1917" strokeWidth={2} dot={false} />
          </LineChart>
        )}
      </ResponsiveContainer>}
    </div>
  );
}

export const moneyK = (v) => (Math.abs(v) >= 1000 ? `$${(v / 1000).toFixed(v >= 10000 ? 0 : 1)}k` : money(v));
export { BarChart, Bar, ReferenceLine };
